import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
export var FormMessageType;
(function (FormMessageType) {
    FormMessageType[FormMessageType["ERROR"] = 1] = "ERROR";
    FormMessageType[FormMessageType["INFO"] = 2] = "INFO";
})(FormMessageType || (FormMessageType = {}));
const FormMessage = props => {
    const { message, type } = props;
    const { t } = useTranslation([
        I18N_NAMESPACES.account,
        I18N_NAMESPACES.buy,
        I18N_NAMESPACES.dpe,
        I18N_NAMESPACES.navigation,
    ]);
    const setTypeClass = () => {
        switch (type) {
            case FormMessageType.INFO:
                return 'a-form-message--info';
            default:
                return 'a-form-message--error';
        }
    };
    return _jsx("div", { className: `a-form-message ${setTypeClass()}`, children: t(message) });
};
export { FormMessage };
